import { Box, Container, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};


let esc = '';
let gra = '';
let car = '';
class FichaCalificaciones extends Component {
    constructor(props){
        super(props);
        this.state = {
            notificaciones: null,
            errores: null,
            consulta: false,
            grados: [],
            escalafones: [],
            cargos: [],
            numeroNombre: [],
            calificacionesFuncionario: [],
            calificacionesFuncionario2: [],
            modalActualizar: false,
            modalBorrar: false,


            calificaciones: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                escalafon: '',
                grado: '',
                cargo: '',
                anio: '',
                puntaje: '0.00',
                fechaActual: '',
            },

            calEditar: {
                idCalificaciones: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                escalafon: '',
                grado: '',
                cargo: '',
                anio: '',
                puntaje: '0.00',
                fechaActual: '',
            },

            busqueda: {
                numeroFuncionarioBusqueda: '',
            },

        }

        this.manejarCambioNumFun = this.manejarCambioNumFun.bind(this);
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejarEnvioMovimiento = this.manejarEnvioMovimiento.bind(this);
        this.manejarAtras = this.manejarAtras.bind(this);
        this.manejoEnvioNumeroFuncionario = this.manejoEnvioNumeroFuncionario.bind(this);
        this.manejarEdicion = this.manejarEdicion.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
        this.manejarEnvioModificar = this.manejarEnvioModificar.bind(this);
        this.manejarCambioEditar = this.manejarCambioEditar.bind(this);
        this.obtenerCal = this.obtenerCal.bind(this);
        this.manejarBorrar = this.manejarBorrar.bind(this);
        this.manejarEnvioBaja = this.manejarEnvioBaja.bind(this);
    }

    async componentDidMount(){

        const fech = new Date();
        const anioAnterior = fech.getFullYear() - 1;
        this.setState(state => {
            const calificacionesActualizadas = state.calificaciones;
            calificacionesActualizadas['anio'] = String(anioAnterior);
            calificacionesActualizadas['fechaActual'] = fech.toISOString().substring(0,10);
            return{
                calificaciones: calificacionesActualizadas,
            }
        });


        const datosGrados = await fetch(`${Constantes.RUTA_API}/obtener_grados.php`);
        const datoGrado = await datosGrados.json();
        this.setState({
            grados: datoGrado,
        });

        const datosEscalafones = await fetch(`${Constantes.RUTA_API}/obtener_escalafones.php`);
        const datoEscalafon = await datosEscalafones.json();
        this.setState({
            escalafones: datoEscalafon,
        });

        const datosCargos = await fetch(`${Constantes.RUTA_API}/obtener_cargos.php`);
        const datoCargo = await datosCargos.json();
        this.setState({
            cargos: datoCargo,
        });

        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombre.php`);
        const datosNumNom = await numNom.json();
        this.setState({
            numeroNombre: datosNumNom,
        });
    }


    render(){
        return (
            <>
                <Container>
                    <h3>Ficha de Calificaciones</h3>
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}

                <form className='formulario1' onSubmit={this.manejoEnvioNumeroFuncionario}>
                    <Box sx={{flexGrow: 1}} >
                        <Grid container spacing={2} rowSpacing={1}>
                            <Grid item xs={2.5}>
                                <Item>Número de Funcionario</Item>
                            </Grid>
                            <Grid item xs={3}>
                                <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='numeroFuncionarioBusqueda' value={this.state.busqueda.numeroFuncionarioBusqueda} onChange={this.manejarCambioNumFun} type="number" /></Item>
                            </Grid>
                            <Grid item xs={1}>
                                <button className="btn btn-outline-primary mx-2" type='submit'>Buscar</button>
                            </Grid>
                        </Grid>
                    </Box>
                </form>
                <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                    <Table sx={{minWidth: 700}}>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Número</StyledTableCell>
                            <StyledTableCell>Nombre</StyledTableCell>
                            <StyledTableCell>Escalafon</StyledTableCell>
                            <StyledTableCell>Grado</StyledTableCell>
                            <StyledTableCell>Cargo</StyledTableCell>
                            <StyledTableCell>Año</StyledTableCell>
                            <StyledTableCell>Puntaje</StyledTableCell>
                            {this.state.consulta ? <StyledTableCell></StyledTableCell> : ''}
                            {this.state.consulta ? <StyledTableCell></StyledTableCell> : ''}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {/*Acá van los datos que vienen de la base de datos */}
                        {this.state.calificacionesFuncionario.map((calificacionAg) => (
                            <StyledTableRow key={calificacionAg.idCalificaciones}>
                                <StyledTableCell>{calificacionAg.numeroFuncionario}</StyledTableCell>
                                <StyledTableCell>{calificacionAg.nombreFuncionario}</StyledTableCell>
                                {this.state.escalafones.map((name) => {
                                    if(name.idEscalafon === calificacionAg.escalafon){
                                        esc = name.descripcion;
                                    }
                                })}
                                <StyledTableCell>{esc}</StyledTableCell>
                                {/*<StyledTableCell>
                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='escalafon'  value={calificacionAg.escalafon} onChange={this.manejarCambiosDatos}>
                                        <option value=''>ESCALAFON</option>
                                        {this.state.escalafones.map((name) =>
                                            <option
                                            key={name.idEscalafon}
                                            value={name.idEscalafon}
                                            >{name.descripcion}</option>
                                            )}
                                    </select>
                                </StyledTableCell>*/}
                                {this.state.grados.map((name) => {
                                    if(name.idGrado === calificacionAg.grado){
                                        gra = name.descripcion;
                                    }
                                })}
                                <StyledTableCell>{gra}</StyledTableCell>
                                {/*<StyledTableCell>
                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='grado'  value={calificacionAg.grado} onChange={this.manejarCambiosDatos}>
                                        <option value=''>GRADO</option>
                                        {this.state.grados.map((name) =>
                                            <option
                                            key={name.idGrado}
                                            value={name.idGrado}
                                            >{name.descripcion}</option>
                                            )}
                                    </select>
                                </StyledTableCell>*/}
                                {this.state.cargos.map((name) => {
                                    if(name.idCargo === calificacionAg.cargo){
                                        car = name.descripcion;
                                    }
                                })}
                                <StyledTableCell>{car}</StyledTableCell>
                                {/*<StyledTableCell>
                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='cargo'  value={calificacionAg.cargo} onChange={this.manejarCambiosDatos}>
                                        <option value=''>CARGO</option>
                                        {this.state.cargos.map((name) =>
                                            <option
                                            key={name.idCargo}
                                            value={name.idCargo}
                                            >{name.descripcion}</option>
                                            )}
                                    </select>
                                </StyledTableCell>*/}
                                <StyledTableCell>{calificacionAg.anio}</StyledTableCell>
                                <StyledTableCell>{calificacionAg.puntaje}</StyledTableCell>
                                <StyledTableCell><button className="btn btn-outline-danger mx-2" onClick={() => this.manejarEdicion(calificacionAg)}>Editar</button></StyledTableCell>
                                <StyledTableCell><button className="btn btn-outline-dark mx-2" type='button' onClick={() => this.manejarBorrar(calificacionAg)}>Borrar</button></StyledTableCell>
                            </StyledTableRow>
                        ))}
                        {this.state.consulta ? '' : <StyledTableRow>
                            <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroFuncionario' value={this.state.calificaciones.numeroFuncionario} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                            <StyledTableCell>{this.state.calificaciones.nombreFuncionario}</StyledTableCell>
                            <StyledTableCell>
                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='escalafon'  value={this.state.calificaciones.escalafon} onChange={this.manejarCambiosDatos}>
                                    <option value=''>ESCALAFON</option>
                                    {this.state.escalafones.map((name) =>
                                        <option
                                        key={name.idEscalafon}
                                        value={name.idEscalafon}
                                        >{name.descripcion}</option>
                                        )}
                                </select>
                            </StyledTableCell>
                            <StyledTableCell>
                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='grado'  value={this.state.calificaciones.grado} onChange={this.manejarCambiosDatos}>
                                    <option value=''>GRADO</option>
                                    {this.state.grados.map((name) =>
                                        <option
                                        key={name.idGrado}
                                        value={name.idGrado}
                                        >{name.descripcion}</option>
                                        )}
                                </select>
                            </StyledTableCell>
                            <StyledTableCell>
                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='cargo'  value={this.state.calificaciones.cargo} onChange={this.manejarCambiosDatos}>
                                    <option value=''>CARGO</option>
                                    {this.state.cargos.map((name) =>
                                        <option
                                        key={name.idCargo}
                                        value={name.idCargo}
                                        >{name.descripcion}</option>
                                        )}
                                </select>
                            </StyledTableCell>
                            <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='anio' value={this.state.calificaciones.anio} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                            <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='puntaje' value={this.state.calificaciones.puntaje} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                        </StyledTableRow>
                        }
                    </TableBody>
                    </Table>
                </TableContainer>
                    {this.state.consulta ? '' : <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioMovimiento}>Agregar</button>}
                    {this.state.consulta ? <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtras}>Volver</button> : ''}
                </Container>
                <Modal open={this.state.modalActualizar}>
                    <form className='formulario1'>
                        <Box sx={styleModal}>
                        <h3 style={{textAlign:'center'}}>Editar Calificación</h3>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={6}>
                                    <Item>Número de Funcionario</Item>
                                </Grid>
                                <Grid item xs={4}>
                                    <Item>{this.state.calEditar.numeroFuncionario}</Item>
                                </Grid>
                                <Grid item xs={2}>

                                </Grid>
                                <Grid item xs={6}>
                                    <Item>Escalafon</Item>
                                </Grid>
                                <Grid item xs={4}>
                                    <Item>
                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='escalafon'  value={this.state.calEditar.escalafon} onChange={this.manejarCambioEditar}>
                                        <option value=''>ESCALAFON</option>
                                        {this.state.escalafones.map((name) =>
                                            <option
                                            key={name.idEscalafon}
                                            value={name.idEscalafon}
                                            >{name.descripcion}</option>
                                        )}
                                    </select>
                                    </Item>
                                </Grid>
                                <Grid item xs={2}>

                                </Grid>
                                <Grid item xs={6}>
                                    <Item>Grado</Item>
                                </Grid>
                                <Grid item xs={4}>
                                    <Item>
                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='grado'  value={this.state.calEditar.grado} onChange={this.manejarCambioEditar}>
                                        <option value=''>GRADO</option>
                                        {this.state.grados.map((name) =>
                                            <option
                                            key={name.idGrado}
                                            value={name.idGrado}
                                            >{name.descripcion}</option>
                                            )}
                                    </select>
                                    </Item>
                                </Grid>
                                <Grid item xs={2}>

                                </Grid>
                                <Grid item xs={6}>
                                    <Item>Cargo</Item>
                                </Grid>
                                <Grid item xs={4}>
                                    <Item>
                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='cargo'  value={this.state.calEditar.cargo} onChange={this.manejarCambioEditar}>
                                        <option value=''>CARGO</option>
                                        {this.state.cargos.map((name) =>
                                            <option
                                            key={name.idCargo}
                                            value={name.idCargo}
                                            >{name.descripcion}</option>
                                            )}
                                    </select>
                                    </Item>
                                </Grid>
                                <Grid item xs={2}>

                                </Grid>
                                <Grid item xs={6}>
                                    <Item>Año</Item>
                                </Grid>
                                <Grid item xs={4}>
                                    <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='anio' value={this.state.calEditar.anio} onChange={this.manejarCambioEditar} type="text" /></Item>
                                </Grid>
                                <Grid item xs={2}>

                                </Grid>
                                <Grid item xs={6}>
                                    <Item>Puntaje</Item>
                                </Grid>
                                <Grid item xs={4}>
                                    <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='anio' value={this.state.calEditar.puntaje} onChange={this.manejarCambioEditar} type="number" /></Item>
                                </Grid>
                                <Grid item xs={2}>

                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioModificar}>Confirmar</button>
                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                </Modal>
                <Modal open={this.state.modalBorrar}>
                    <form className='formulario1'>
                        <Box sx={styleModal} >
                        <h3 style={{textAlign:'center'}}>¿Confirmar Baja Calificación?</h3>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2}>

                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioBaja}>Confirmar</button>
                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                </Modal>
            </>
        )//Final del return
    }//Final render

    manejarCambioNumFun(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state =>{
            const busquedaActualizada = state.busqueda;
            busquedaActualizada[clave] = valor;
            return {
                busqueda: busquedaActualizada,
            }
        });
    }

    async manejoEnvioNumeroFuncionario(e){
        e.preventDefault();
        if(this.state.busqueda.numeroFuncionarioBusqueda === ''){
            this.setState({
                errores: 'Debe ingresar un número de funcionario',
            });
        }else{
            this.setState({
                errores: null,
                notificaciones: null,
            });
            const cargaUtil = JSON.stringify(this.state.busqueda);

            const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_calificaciones.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();
            if(exito){
                if(exito.length !== 0){
                    this.setState({
                        consulta: true,
                        calificacionesFuncionario: exito,
                        calificacionesFuncionario2: exito,
                    });
                }else{
                    this.setState({
                        consulta: false,
                        calificacionesFuncionario: [],
                        calificacionesFuncionario2: [],
                        errores: 'No existen calificaciones para el número de funcionario ingresado!',
                    });
                }
            }

        }
    }

    manejarEdicion(cal){
        this.setState({
            modalActualizar: true,
            calEditar: cal,
            notificaciones: null,
            errores: null,
        });
    }

    async obtenerCal(e){
        const cargaUtil = JSON.stringify(this.state.busqueda);

        const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_calificaciones.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            calificacionesFuncionario: exito,
            calificacionesFuncionario2: exito,
        });
    } 

    cerrarModal(e){
        e.preventDefault();
        this.obtenerCal();
        this.setState({
            modalActualizar: false,
            modalBorrar: false,
        });
    }

    manejarCambioEditar(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const calEditarActualizado = state.calEditar;

            calEditarActualizado[clave] = valor;
            return {
                calEditar: calEditarActualizado,
            }
        })
    }

    async manejarEnvioModificar(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify(this.state.calEditar);

        const respuesta = await fetch(`${Constantes.RUTA_API}/editar_calificacion.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            errores: exito,
            modalActualizar: false,
        });
        if(exito === 'ok'){
            this.setState({
                notificaciones: 'Los datos fueron ingresados correctamente',
                modalActualizar: false,
                errores: null,
            });
        }
    }

    manejarBorrar(dato){
        this.setState({
            modalBorrar: true,
            calEditar: dato,
            notificaciones: null,
        });
    }

    async manejarEnvioBaja(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify(this.state.calEditar);

        const respuesta = await fetch(`${Constantes.RUTA_API}/borrar_calificacion.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        if(exito){
            let contador = 0;
            const arr = this.state.calificacionesFuncionario;
            arr.map((name) => {
                if(this.state.calEditar.idCalificaciones === name.idCalificaciones){
                    arr.splice(contador, 1);
                }else{
                    contador++;
                }
            });
            this.setState({
                notificaciones: 'Los datos fueron borrados correctamente',
                modalBorrar: false,
                calificacionesFuncionario: arr,
            });
        }
    }


    manejarCambiosDatos(e){
        e.preventDefault();
        this.setState({
            notificaciones: null,
            errores: null,
        });
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const calificacionesActualizada = state.calificaciones;
            if(clave === 'numeroFuncionario'){
                //valor = parseFloat(valor);
                //Tengo que buscar la informacion de ese funcionario
                let aux = true;
                this.state.numeroNombre.map((name) =>
                {if(name.numeroFuncionario === valor){
                    calificacionesActualizada['nombreFuncionario'] = name.primerNombre + ' ' + name.primerApellido;
                    aux = false;
                }else if(aux){
                    calificacionesActualizada['nombreFuncionario'] = '';
                }
                });
            }else if(clave === 'puntaje'){

            }
            calificacionesActualizada[clave] = valor;
            return{
                movimientos: calificacionesActualizada,
            };
        });
    }

    async manejarEnvioMovimiento(e){
        e.preventDefault();
        if(this.state.calificaciones.numeroFuncionario === ''){
            this.setState({
                errores: 'Debe ingresar un número de funcionario!',
            });
        }else if(this.state.calificaciones.nombreFuncionario === ''){
            this.setState({
                errores: 'Debe ingresar un numero de funcionario valido!',
            });
        }else if(this.state.calificaciones.escalafon === ''){
            this.setState({
                errores: 'Debe indicar el escalafon!',
            });
        }else if(this.state.calificaciones.grado === ''){
            this.setState({
                errores: 'Debe indicar el grado!',
            });
        }else if(this.state.calificaciones.cargo === ''){
            this.setState({
                errores: 'Debe indicar el cargo!',
            });
        }else if(this.state.calificaciones.anio === ''){
            this.setState({
                errores: 'Debe ingresar el año!',
            });
        }else if(this.state.calificaciones.anio.length !== 4){
            console.log(this.state.calificaciones.anio);
            this.setState({
                errores: 'El año debe ser YYYY!',
            });
        }else if(this.state.calificaciones.puntaje === '0.00'){
            this.setState({
                errores: 'Debe ingresar el puntaje!',
            });
        }else{
            const cargaUtil = JSON.stringify(this.state.calificaciones);

            const control = await fetch(`${Constantes.RUTA_API}/guardar_calificacion.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                errores: res,
            });
            const fech = new Date();
            const anioAnterior = fech.getFullYear() - 1;
            if(res === 'ok'){
                this.setState({
                    notificaciones: 'Los datos fueron ingresados correctamente',
                    errores: null,
                    calificaciones: {
                        numeroFuncionario: '',
                        nombreFuncionario: '',
                        escalafon: '',
                        grado: '',
                        cargo: '',
                        anio: anioAnterior,
                        puntaje: '0.00',
                        fechaActual: fech,
                    },
                });
            }
        }
    }

    manejarAtras(e){
        e.preventDefault();
        const a = new Date().getFullYear();
        this.setState({
            consulta: false,
            calificacionesFuncionario: [],
            errores: null,
            notificaciones: null,
        });
        const fech = new Date();
        const anioAnterior = fech.getFullYear() - 1;
        this.setState(state => {
            const calificacionesActualizadas = state.calificaciones;
            calificacionesActualizadas['anio'] = String(anioAnterior);
            calificacionesActualizadas['fechaActual'] = fech.toISOString().substring(0,10);
            return{
                calificaciones: calificacionesActualizadas,
            }
        });
    }

}

export default FichaCalificaciones